import SortedArray from "../../HelperModules/SortedArray.js";
import { MetadataEvent } from "../Notation/SongEvents.js";
export default class SongMetadata {
    constructor(bpm = 60, timeSignature = [4, 4]) {
        this._metaEvents = new SortedArray(MetadataEvent.comparator);
        this._metaEventSecondLengths = [];
        this._metaEventBarLengths = [];
        this._metaEventBeatLengths = [];
        this.addMetadataEvent(0, bpm, timeSignature);
    }
    get events() {
        return this._metaEvents;
    }
    getBPM(time) {
        return this._metaEvents[this._metaEvents.binarySearch(time, true)].bpm;
    }
    getSecondsPerBeat(time) {
        return this._metaEvents[this._metaEvents.binarySearch(time, true)].secondsPerBeat;
    }
    getTimeSignature(time) {
        return this._metaEvents[this._metaEvents.binarySearch(time, true)].timeSignature;
    }
    getQuarterNoteMultiplier(time) {
        return this._metaEvents[this._metaEvents.binarySearch(time, true)].quarterNoteMultiplier;
    }
    positionQuarterNoteToSeconds(time) {
        if (time === undefined || time < 0) {
            throw new RangeError("Time is invalid");
        }
        let index = this._metaEvents.binarySearch(time, true);
        if (index == 0) {
            return time * this._metaEvents[index].quarterNoteMultiplier * this._metaEvents[index].secondsPerBeat;
        }
        else {
            return this._metaEventSecondLengths[index] + (time - this._metaEvents[index].startPosition) * this._metaEvents[index].quarterNoteMultiplier * this._metaEvents[index].secondsPerBeat;
        }
    }
    positionSecondsToQuarterNote(time) {
        for (let i = this._metaEventSecondLengths.length - 1; i >= 0; i--) {
            if (time >= this._metaEventSecondLengths[i]) {
                return this._metaEvents[i].startPosition + (((time - this._metaEventSecondLengths[i]) / this._metaEvents[i].secondsPerBeat) / this._metaEvents[i].quarterNoteMultiplier);
            }
        }
    }
    positionQuarterNoteToBars(time) {
        if (time === undefined || time < 0) {
            throw new RangeError("Time is invalid");
        }
        let index = this._metaEvents.binarySearch(time, true);
        if (index == 0) {
            return (time * this._metaEvents[index].quarterNoteMultiplier) / this._metaEvents[index].timeSignature[0];
        }
        else {
            return this._metaEventBarLengths[index] + (((time - this._metaEvents[index].startPosition) * this._metaEvents[index].quarterNoteMultiplier) / this._metaEvents[index].timeSignature[0]);
        }
    }
    positionBarsToQuarterNote(time) {
        for (let i = this._metaEventBarLengths.length - 1; i >= 0; i--) {
            if (time >= this._metaEventBarLengths[i]) {
                return this._metaEvents[i].startPosition + (((time - this._metaEventBarLengths[i]) * this._metaEvents[i].timeSignature[0]) / this._metaEvents[i].quarterNoteMultiplier);
            }
        }
    }
    positionQuarterNoteToBeats(time) {
        if (time === undefined || time < 0) {
            throw new RangeError("Time is invalid");
        }
        let index = this._metaEvents.binarySearch(time, true);
        if (index == 0) {
            return (time * this._metaEvents[index].quarterNoteMultiplier);
        }
        else {
            return this._metaEventBeatLengths[index] + ((time - this._metaEvents[index].startPosition) * this._metaEvents[index].quarterNoteMultiplier);
        }
    }
    positionBeatsToQuarterNote(time) {
        for (let i = this._metaEventBeatLengths.length - 1; i >= 0; i--) {
            if (time >= this._metaEventBeatLengths[i]) {
                return this._metaEvents[i].startPosition + ((time - this._metaEventBeatLengths[i]) / this._metaEvents[i].quarterNoteMultiplier);
            }
        }
    }
    addMetadataEvent(time, bpm, timeSignature) {
        let index = this._metaEvents.binarySearch(time);
        if (index === -1) {
            index = this._metaEvents.insert(new MetadataEvent(time, bpm, timeSignature));
        }
        else {
            this._metaEvents[index].originalStartPosition = time;
            this._metaEvents[index].bpm = bpm,
                this._metaEvents[index].timeSignature = timeSignature;
        }
        this.precalculateLengths();
        let indicesToRemove = [];
        for (let i = index + 1; i < this._metaEvents.length; i++) {
            let prevEvent = this._metaEvents[i - 1];
            let roundedBarPosition = Math.round(((this._metaEvents[i].originalStartPosition - prevEvent.startPosition) * prevEvent.quarterNoteMultiplier) / prevEvent.timeSignature[0]);
            let newPosition = prevEvent.startPosition + ((roundedBarPosition) * prevEvent.timeSignature[0]) / prevEvent.quarterNoteMultiplier;
            if (newPosition != this._metaEvents[i].startPosition && this._metaEvents.binarySearch(newPosition) != -1) {
                indicesToRemove.push(i);
            }
            else {
                this._metaEvents[i].startPosition = newPosition;
                this.precalculateLengths();
            }
        }
        if (indicesToRemove.length > 0) {
            indicesToRemove.forEach(index => { this._metaEvents.removeAt(index); });
            this.precalculateLengths();
        }
        return this._metaEvents[index];
    }
    removeMetadataEvent(time) {
        if (time == 0) {
            throw new RangeError("Cannot remove initial event.");
        }
        let index = this._metaEvents.binarySearch(time);
        if (index == -1) {
            throw new RangeError("Event does not exist at this time.");
        }
        this._metaEvents.removeAt(index);
        this.precalculateLengths();
    }
    precalculateLengths() {
        this._metaEventSecondLengths = [0];
        this._metaEventBarLengths = [0];
        this._metaEventBeatLengths = [0];
        let totalSecondsDuration = 0;
        let totalBarsDuration = 0;
        let totalBeatsDuration = 0;
        for (let i = 1; i < this._metaEvents.length; i++) {
            let quarterNoteDuration = this._metaEvents[i].startPosition - this._metaEvents[i - 1].startPosition;
            totalSecondsDuration += quarterNoteDuration * this._metaEvents[i - 1].quarterNoteMultiplier * this._metaEvents[i - 1].secondsPerBeat;
            this._metaEventSecondLengths.push(totalSecondsDuration);
            totalBarsDuration += (quarterNoteDuration * this._metaEvents[i - 1].quarterNoteMultiplier) / this._metaEvents[i - 1].timeSignature[0];
            this._metaEventBarLengths.push(totalBarsDuration);
            totalBeatsDuration += (quarterNoteDuration * this._metaEvents[i - 1].quarterNoteMultiplier);
            this._metaEventBeatLengths.push(totalBeatsDuration);
        }
    }
    serialise() {
        let serialisedEvents = [];
        this._metaEvents.forEach(metaEvent => {
            serialisedEvents.push(metaEvent.serialise());
        });
        return serialisedEvents;
    }
    deserialise(metaEvents) {
        this._metaEvents = new SortedArray();
        this.addMetadataEvent(0, 60, [4, 4]);
        metaEvents.forEach(metaEvent => {
            if (metaEvent.eventType === "MetadataEvent") {
                this.addMetadataEvent(metaEvent.startPosition, metaEvent.bpm, metaEvent.timeSignature);
            }
            else {
                console.log("SongMetadata does not support this event type.");
            }
        });
    }
}
//# sourceMappingURL=SongMetadata.js.map